// "Your units (n)" strip on top of the Home list (M3-F2, M3.26, DC-113): one chip per booking with its
// stage; an orange dot when the customer must act; clicking scrolls to that card.
// Shown only when the customer has at least one CRM 2.0 booking; old bookings show as
// "Agreement (booked before CRM 2.0)".
import React, { useEffect, useState } from "react";
import { getCrm2Cards } from "../../../Services/Crm2Booking";
import css from "./Crm2Booking.module.css";

const unitLabel = (ap) => {
	const u = ap?.unitId || ap?.inventoryMergedId?.unit1Id;
	const w = u?.wingId?.displayName || u?.wingId?.wingName;
	return `${w ? `${w} - ` : ""}${u?.unitNo ?? ""}`;
};
const projectOf = (ap) => (ap?.unitId?.projectId?.projectName || ap?.inventoryMergedId?.projectId?.projectName || "").split(" ").slice(0, 2).join(" ");

// what the customer has to do now on a CRM 2.0 card
function mustAct(c) {
	if (!c || c.stage === "CANCELLED") return false;
	if (c.stage === 0) return true;
	if (c.stage !== 1 || c.bookingState === "WAITING_RM") return false;
	const afbOk = !!c.afb?.confirmedAt || (c.steps?.[1] || []).some((s) => s.stepCode === "AFB_CONFIRMED" && s.status === "DONE");
	return !afbOk || !c.kycFilled || !!c.kyc?.correction || (c.reviewDraft?.status === "READY" && !c.reviewDraft?.allConfirmed);
}

export default function Crm2UnitsStrip({ items }) {
	const [cards, setCards] = useState({});
	const hasCrm2 = items.some((d) => d.allotment?.isCrm2);
	const key = items.map((d) => `${d.allotment?.allotmentPaymentId}:${d.allotment?.status}`).join("|");

	useEffect(() => {
		if (!hasCrm2) return;
		getCrm2Cards()
			.then((list) => setCards(Object.fromEntries((list || []).filter((c) => c?.isCrm2).map((c) => [c.allotmentPaymentId, c]))))
			.catch((err) => console.warn("[crm2][portal] units strip not loaded", err.message));
	}, [hasCrm2, key]);

	if (!hasCrm2) return null;
	const units = items.filter((d) => d.allotment);
	return (
		<div className={css.ustrip}>
			<b>Your units ({units.length})</b>
			{units.map((d) => {
				const ap = d.allotment;
				const c = ap.isCrm2 ? cards[ap.allotmentPaymentId] : null;
				const stage = ap.isCrm2
					? c
						? c.bookingState === "WAITING_RM"
							? "Waiting for your Relationship Manager"
							: c.stage === 0
								? c.money?.paid > 0
									? "Shortlisted · balance booking amount"
									: "Shortlisted · pay booking amount"
								: c.stageName
						: ""
					: "Agreement (booked before CRM 2.0)";
				return (
					<button
						type="button"
						key={ap.allotmentPaymentId}
						className={`${css.uchip} ${mustAct(c) ? css.act : ""}`}
						onClick={() => document.getElementById(`u-${ap.allotmentPaymentId}`)?.scrollIntoView({ behavior: "smooth" })}
					>
						<span className={css.ud} />
						<span>
							<b>{unitLabel(ap)}</b> · {projectOf(ap)}
							<br />
							<em>{stage}</em>
						</span>
					</button>
				);
			})}
		</div>
	);
}
